import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactGA4 from "react-ga4";
import { Provider } from "mobx-react";
import * as Sentry from "@sentry/react";
import { OverlayProvider } from "overlay-kit";

import "./static-file/css/index.css";
import OrderStore from "./stores/OrderStore";
import SearchStore from "./stores/SearchStore";
import ViewStore from "./stores/ViewStore";
import SettingStore from "./stores/SettingStore";
import LayerStore from "./stores/LayerStore";
import DeliveryStore from "./stores/DeliveryStore";
import RabbitMqStore from "./stores/RabbitMqStore";
import EndOrderStore from "./stores/EndOrderStore";
import SalesStore from "./stores/SalesStore";
import MenuStore from "./stores/MenuStore";
import PageStore from "./stores/pageStore";
import TimerStore from "./stores/TimerStore";
import ModalStore from "stores/ModalStore";
import { initSentry } from "./libs/sentry";
import history from "./shared/History";
import SettingEndOrderView from "views/setting/SettingEndOrderView";
import MainOrderListContainer from "containers/main/MainOrderListContainer";
import App from "./App";
import { ErrorFallback } from "components/error/ErrorFallback";
import { logService } from "utils/logService";

// 에러 모니터링 설정
initSentry();
const queryClient = new QueryClient();

const rootStores = {
  settingStore: SettingStore,
  orderStore: OrderStore,
  searchStore: SearchStore,
  viewStore: ViewStore,
  layerStore: LayerStore,
  deliveryStore: DeliveryStore,
  rabbitMqStore: RabbitMqStore,
  endOrderStore: EndOrderStore,
  salesStore: SalesStore,
  menuStore: MenuStore,
  pageStore: PageStore,
  timerStore: TimerStore,
  modalStore: ModalStore,
};

const targetComponent = {
  SettingEndOrderView: SettingEndOrderView,
  MainOrderListContainer: MainOrderListContainer,
};

ReactGA4.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    ReactGA4.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
}

function GoogleAnalytics() {
  usePageViews();
  ReactGA4.set({ userId: rootStores.searchStore.getShopCd });
  return <></>;
}

ReactDOM.render(
  <Provider rootStore={rootStores} component={targetComponent}>
    <BrowserRouter basename={process.env.PUBLIC_URL} history={history}>
      <QueryClientProvider client={queryClient}>
        <OverlayProvider>
          <Sentry.ErrorBoundary
            fallback={props => <ErrorFallback {...props} rootStore={rootStores} />}
            onError={(error, componentStack, eventId) => {
              logService(error, componentStack, eventId);
            }}
          >
            <App />
          </Sentry.ErrorBoundary>
          <GoogleAnalytics />
        </OverlayProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
